<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="goodsSkuId">
      <a-input v-model="form.data.goodsSkuId"/>
    </a-form-model-item>
    <a-form-model-item label="quantity">
      <a-input v-model="form.data.quantity"/>
    </a-form-model-item>
    <a-form-model-item label="amount">
      <a-input v-model="form.data.amount"/>
    </a-form-model-item>
    <a-form-model-item label="userId">
      <a-input v-model="form.data.userId"/>
    </a-form-model-item>
    <a-form-model-item label="status">
      <a-input v-model="form.data.status"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button
        type="primary"
        v-if="!orderId"
@click="onAdd">{{ $t('CREATE') || '创建' }}</a-button>
        <a-button
        type="primary"
v-if="orderId"
@click="onUpdate">{{ $t('UPDATE') || '更新' }}</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryOrder,
  _addOrder,
  _updateOrder,
} from '@/api/orderApi';

async function getOrder() {
  const result = await _queryOrder(this.orderId);
  if (result) {
    this.form.data.goodsSkuId = result.order.goodsSkuId;
    this.form.data.quantity = result.order.quantity;
    this.form.data.amount = result.order.amount;
    this.form.data.userId = result.order.userId;
    this.form.data.status = result.order.status;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addOrder({
        goodsSkuId: this.form.goodsSkuId,
        quantity: this.form.quantity,
        amount: this.form.amount,
        userId: this.form.userId,
        status: this.form.status,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateOrder(this.orderId, {
        goodsSkuId: this.form.data.goodsSkuId,
        quantity: this.form.data.quantity,
        amount: this.form.data.amount,
        userId: this.form.data.userId,
        status: this.form.data.status,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'OrderEdit',
  props: {
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    orderId() {
      if (this.orderId) {
        this.getOrder();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getOrder,
  },
  data() {
    return {
      form: {
        data: {
          goodsSkuId: '',
          quantity: '',
          amount: '',
          userId: '',
          status: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.orderId) {
      this.getOrder();
    }
  },
};
</script>
